import { CashIcon, ClipboardCheckIcon, ClockIcon, CogIcon, LockClosedIcon, LogoutIcon, UserAddIcon } from '@heroicons/react/solid'

import WalletModal from './Wallet/'
import LogoutModal from './Logout'
import AuthModal from './Auth/'
import PlayerStats from './PlayerStats'
import CreateDuel from './Duel/CreateDuel'
import StartDuel from './Duel/StartDuel'
import Race from './Race'
import LinkAccount from './LinkAccount'
import SetUsername from './SetUsername'
import ForgotPassword from './ForgotPassword'

export default {
  wallet: {
    component: <WalletModal />,
    icon: <CashIcon />,
    title: 'Wallet',
    show2fa: true
  },
  logout: {
    component: <LogoutModal />,
    icon: <LogoutIcon />,
    title: 'Logout',
  },
  forgotPassword: {
    component: <ForgotPassword />,
    icon: <CogIcon />,
    title: 'Forgot Password',
  },
  auth: {
    component: <AuthModal />,
    hideHeader: true,
    public: true,
    size: 'large',
    padding: false
  },
  user: {
    component: <PlayerStats />,
    icon: <ClipboardCheckIcon />,
    title: "Player Stats"
  },
  createDuel: {
    component: <CreateDuel />,
    icon: <LockClosedIcon />,
    title: 'Create Duel'
  },
  race: {
    component: <Race />,
    icon: <ClockIcon />,
    title: 'Race'
  },
  startDuel: {
    component: <StartDuel />,
    hideHeader: true,
    size: 'xlarge',
    padding: false
  },
  linkAccount: {
    component: <LinkAccount />,
    icon: <UserAddIcon />,
    title: 'Link Account'
  },
  setUsername: {
    component: <SetUsername />,
    icon: <UserAddIcon />,
    title: 'Set Username'
  }
}